<mat-card
  *ngIf="formModel"
  class="dm__card mat-elevation-z0"
  fxLayout="column"
  fxLayoutGap="15px"
>

  <div cdkDropListGroup fxLayout="row" fxLayoutGap="15px">
    <!-- champs dispo / ajout bloc -->
    <div class="dm__list__elements stiky__content" fxFlex="17">
      <div>
        <h3 class="dm__subheader padding__l16">Champs disponibles</h3>
        <button (click)="addNewBlock()"
                color="accent"
                mat-button
                data-cy="button-form-builder-new-block"
        ><mat-icon>add</mat-icon> Ajouter un bloc
        </button>
      </div>
      <app-dm-elements></app-dm-elements>
    </div>
    <div fxFlex="20"></div>
    <!-- formulaire informations -->
    <fieldset class="dm__form" fxFlex>
      <legend class="legende__typeform">Type de Formulaire: {{formType[formModel.type]}}</legend>
      <div class="form__infos">

        <div fxLayout="row">
          <div fxFlex>
            <h3 class="mat-subheader dm__subheader">
              {{formModel.nom}}
              <button (click)="editTitleForm(formModel)" [matTooltipPosition]="'above'" color="accent"
                      mat-icon-button
                      matTooltip="Modifier les infos du formulaire"
                      data-cy="button-form-builder-edit-infos">
                <i class="material-icons">mode_edit</i>
              </button>
            </h3>
            <span *ngIf="formModel?.url_obj && formModel?.url_obj.length > 0 && formModel?.url_obj[0]" matTooltip="le raccourci est un texte compatible pour le lien navigateur">
              <mat-hint>raccourci pour le futur lien demandeur : <span class="mat-h5">{{formModel?.url_obj[0].slug}}</span></mat-hint>
            </span>
          </div>
        </div>
        <div>
          <p mat-line>{{formModel.description}}</p>
        </div>
        <div>
          <p mat-line matTooltip="pour les notifications mails, en plus des gestionnaires">Courriel générique : {{formModel.email_generic || 'aucun'}}</p>
        </div>
      </div>
      <!-- blocs et champs du formulaire -->
      <div class="blocks__container">
        <app-dm-form-block  *ngFor="let itemBlock of formModel.blocks; let idx = index; let lastIdx = last"
                            (moveUpBlock)="onMoveUpBlock($event)"
                            (moveDownBlock)="onMoveDownBlock($event)"
                            (removeBlock)="onRemoveBlock($event)"
                            (closeDialog)="onCloseBlock()"
                            [indexBlock]="idx"
                            [lastIndexBlock]="lastIdx"
                            [itemBlockObj]="itemBlock"
                            [administratifBlockExist]="administratifBlockExist">
        </app-dm-form-block>
      </div>
    </fieldset>
  </div>
</mat-card>
